<script setup>
import {onMounted, ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue'
import {useI18n} from 'vue-i18n';
import Multiselect from '@vueform/multiselect';
import IntermediaryService from '@/services/IntermediaryService';

const {t} = useI18n()
const props = defineProps({
  category: {type: Object, required: false},
});
const showIntermediaries = ref(false);
const intermediaryIds = ref(presetIntermediaries());
const intermediaries = ref([]);
const form = ref({...props.category});
const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);
const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      const formValue = form.value;
      if (showIntermediaries.value) {
        formValue.intermediary_ids = intermediaryIds.value;
      } else {
        formValue.intermediary_ids = null;
      }
      emit('confirm', formValue);
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}

function fetchIntermediaries() {
  IntermediaryService.getAll().then(response => {
    intermediaries.value = response.map(intermediary => {
      return {
        value: intermediary.id,
        label: intermediary.label
      }
    });
  });
}

function presetIntermediaries() {
  if (props.category?.intermediary_ids?.length >= 0) {
    showIntermediaries.value = true;
    return props.category?.intermediary_ids;
  }

  return [];
}

onMounted(() => {
  fetchIntermediaries();
});
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('createDocumentTemplateCategoryModal.create_category') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')">
              <div class="modal-body">
                <div class="row mb-3">
                  <div class="col-12 form-group">
                    <label for="text" class="form-label">{{ t('createDocumentTemplateCategoryModal.name') }}</label>
                    <input type="text" v-model="form.name" class="form-control" id="text"></input>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="form-check">
                    <input type="checkbox" v-model="showIntermediaries" id="showIntermediariesCheck" class="form-check-input" />
                    <label for="showIntermediariesCheck" class="form-check-label">{{ t('createDocumentTemplateCategoryModal.template_for_certain_intermediaries') }}</label>
                  </div>
                  <div v-if="showIntermediaries" class="mb-3">
                    <div class="form-group">
                      <label for="intermediariesSelect" class="form-label">{{ t('createDocumentTemplateCategoryModal.intermediaries') }}</label>
                      <Multiselect id="intermediariesSelect" v-model="intermediaryIds" :options="intermediaries" :close-on-select="false" :hide-selected="false" placeholder="t('createDocumentTemplateCategoryModal.choose_intermediaries')" mode="tags"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">{{ t('createDocumentTemplateCategoryModal.cancel') }}</button>
                <button class="btn btn-primary btn-md" type="submit">{{ t('createDocumentTemplateCategoryModal.save') }}</button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

